<template>
	<div class="page-checkout u-s-p-t-80">
		<div class="container">
			<div class="row">
				<div class="col-lg-12 col-md-12">
					<!-- First-Accordion -->
					<div v-if="!isLoggedIn">
						<div class="message-open u-s-m-b-24">
							Returning customer?
							<strong>
								<a class="u-c-brand" data-toggle="collapse" href="#showlogin"
									>Click here to login
								</a>
							</strong>
						</div>
						<div class="collapse u-s-m-b-24" id="showlogin">
							<h6 class="collapse-h6">Welcome back! Sign in to your account.</h6>
							<h6 class="collapse-h6">
								If you have shopped with us before, please enter your details in the boxes
								below. If you are a new customer, please proceed to the Billing &amp; Shipping
								section.
							</h6>
							<form>
								<div class="group-inline u-s-m-b-13">
									<div class="group-1 u-s-p-r-16">
										<label for="user-name-email"
											>Username or Email
											<span class="astk">*</span>
										</label>
										<input
											type="text"
											id="user-name-email"
											class="text-field"
											placeholder="Username / Email"
										/>
									</div>
									<div class="group-2">
										<label for="password"
											>Password
											<span class="astk">*</span>
										</label>
										<input type="text" id="password" class="text-field" placeholder="Password" />
									</div>
								</div>
								<div class="u-s-m-b-13">
									<button type="submit" class="button button-outline-secondary">Login</button>
									<input type="checkbox" class="check-box" id="remember-me-token" />
									<label class="label-text" for="remember-me-token">Remember me</label>
								</div>
								<div class="page-anchor">
									<a href="#" class="u-c-brand">Lost your password?</a>
								</div>
							</form>
						</div>
					</div>
					<!-- Second Accordion /- -->
					<form>
						<div class="row">
							<!-- Billing-&-Shipping-Details -->
							<div class="col-lg-6">
								<h4 class="section-h4">Shipping Details</h4>
								<!-- Form-Fields -->
								<div class="group-inline u-s-m-b-13">
									<div class="group-1 u-s-p-r-16">
										<label for="first-name"
											>First Name
											<span class="astk">*</span>
										</label>
										<input
											type="text"
											id="first-name"
											class="text-field"
											v-model="form.shipping_first_name"
											required
										/>
									</div>
									<div class="group-2">
										<label for="last-name"
											>Last Name
										</label>
										<input
											type="text"
											id="last-name"
											class="text-field"
											v-model="form.shipping_last_name"
										/>
									</div>
								</div>

								<div class="group-inline u-s-m-b-13">
									<div class="group-1 u-s-p-r-16">
										<label for="Phone Number"
											>Phone Number
											<span class="astk">*</span>
										</label>
										<input
											type="text"
											id="phone_number"
											class="text-field"
											v-model="form.shipping_phone"
										/>
									</div>
								</div>
								<!-- readonly - below control should be readonly -->
								<div class="group-inline u-s-m-b-13">
									<div class="group-1 u-s-p-r-16">
										<label for="email"
											>Address
											<span class="astk">*</span>
										</label>
										<input
											type="text"
											id="address"
											class="text-field"
											v-model="form.shipping_street_address"
										/>
									</div>
								</div>
								<!-- Form-Fields /- -->
								<h4 class="section-h4">Billing Details</h4>
								<div class="u-s-m-b-24">
									<input
										type="checkbox"
										class="check-box"
										id="ship-to-different-address"
										data-toggle="collapse"
										data-target="#showdifferent"
										@click="toggleBilling"
									/>
									<label class="label-text" for="ship-to-different-address"
										>Is Billing address is different from shipping address.</label
									>
								</div>
								<div class="collapse" id="showdifferent">
									<!-- Form-Fields -->
									<div class="group-inline u-s-m-b-13">
										<div class="group-1 u-s-p-r-16">
											<label for="first-name-extra"
												>First Name
												<span class="astk">*</span>
											</label>
											<input
												type="text"
												id="first-name-extra"
												class="text-field"
												v-model="form.billing_first_name"
											/>
										</div>
										<div class="group-2">
											<label for="last-name-extra"
												>Last Name
												<span class="astk">*</span>
											</label>
											<input
												type="text"
												id="last-name-extra"
												class="text-field"
												v-model="form.billing_last_name"
											/>
										</div>
									</div>
									<div class="u-s-m-b-13">
										<label for="town-city-extra">Company </label>
										<input
											type="text"
											id="company"
											class="text-field"
											v-model="form.billing_company"
										/>
									</div>
									<div class="u-s-m-b-13">
										<label for="select-state-extra"
											>State
											<span class="astk"> *</span>
										</label>
										<div class="select-box-wrapper">
											<select class="select-box" id="select-state-extra" v-model="form.state_id">
												<option value="0">Select State</option>
												<option :value="state.id" v-for="state in states" :key="state.id">
													{{ state.name }}
												</option>
											</select>
										</div>
									</div>
									<div class="street-address u-s-m-b-13">
										<label for="req-st-address-extra"
											>Street Address
											<span class="astk">*</span>
										</label>
										<input
											type="text"
											id="req-st-address-extra"
											class="text-field"
											placeholder="House name and street name"
											v-model="form.billing_street_address"
										/>
										<label class="sr-only" for="opt-st-address-extra"></label>
									</div>
									<div class="u-s-m-b-13">
										<label for="town-city-extra"
											>Town / City
											<span class="astk">*</span>
										</label>
										<input
											type="text"
											id="town-city-extra"
											class="text-field"
											v-model="form.billing_city"
										/>
									</div>

									<div class="u-s-m-b-13">
										<label for="postcode-extra"
											>Postcode / Zip
											<span class="astk">*</span>
										</label>
										<input
											type="text"
											id="postcode-extra"
											class="text-field"
											v-model="form.billing_postcode"
										/>
									</div>
									<div class="u-s-m-b-13">
										<label for="postcode-extra"
											>Phone
											<span class="astk">*</span>
										</label>
										<input type="text" id="phone" class="text-field" v-model="form.billing_phone" />
									</div>
									<div class="u-s-m-b-13">
										<label for="postcode-extra"
											>GSTIN
										</label>
										<input type="text" id="phone" class="text-field" v-model="form.gstin" />
									</div>
								</div>
								<div>
									<label for="order-notes">Order Notes</label>
									<textarea
										class="text-area"
										id="order-notes"
										placeholder="Notes about your order, e.g. special notes for delivery."
									></textarea>
								</div>
							</div>
							<!-- Billing-&-Shipping-Details /- -->
							<!-- Checkout -->
							<OrderDetails
								:getCarts="getCarts"
								:getTax="getTax"
								:getTotal="getTotal"
								:coupon="coupon"
								:delivery_fee="GetDeliveryFee"
								:billing_state="form.state_id"
								:warehouse_state="getWarehouseStateId"
								@PlaceOrder="(data) => PlaceOrder(data)"
							/>
							<!-- Checkout /- -->
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
	<LocationModal :current_address="{formatted_address, LatLng}" />
</template>

<script>
	import axios from "axios";
	import OrderDetails from "./OrderDetails.vue";
	import {mapGetters, mapActions} from "vuex";
	import LocationModal from "../Checkout/LocationModal.vue";
	export default {
		components: {OrderDetails, LocationModal},
		computed: {
			...mapGetters("cart", [
				"getCarts",
				"getTax",
				"getTotal",
				"coupon",
				"GetDeliveryFee",
				"getWarehouseStateId",
			]),
			...mapGetters("auth", ["isLoggedIn", "user"]),
		},
		data() {
			return {
				form: {
					billing_first_name: "",
					billing_last_name: "",
					billing_company: "",
					billing_street_address: "",
					billing_city: "",
					billing_postcode: "",
					// billing_country: "IN",
					state_id: "",
					billing_phone: "",
					shipping_first_name: "",
					shipping_last_name: "",
					shipping_company: "",
					shipping_street_address: "",
					shipping_city: "",
					shipping_postcode: "",
					// shipping_country: "IN",
					shipping_state: "",
					shipping_phone: "",
					shipping_alt_phone: "",
					shipping_cost: 0,
					payment_method: "",
					payment_status: "pending",
					order_status: "Inprocess",
					shipping_method: "express",
					transaction_id: 1,
					slot: "",
					gstin: "",
					conversion_id: localStorage.getItem("conversion") || null,
				},
				isBillingIsSameAsShipping: true,
				currentAddress: "",
				LatLng: {lat: "", lng: ""},
				formatted_address: "",
				states: [],
			};
		},
		methods: {
			...mapActions("orders", ["placeOrder"]),
			toggleBilling() {
				this.isBillingIsSameAsShipping = !this.isBillingIsSameAsShipping;
				this.BillingIsSameAsShipping(this.isBillingIsSameAsShipping);
			},
			BillingIsSameAsShipping(value) {
				console.log(value);
				if (value) {
					this.copyBillingAddressToShippingAddress();
				} else {
					this.form.billing_first_name = "";
					this.form.billing_last_name = "";
					this.form.billing_company = "";
					this.form.billing_street_address = "";
					this.form.billing_city = "";
					// this.form.billing_country = "";
					this.form.state_id = "";
					this.form.billing_phone = "";
				}
			},
			copyBillingAddressToShippingAddress() {
				this.form.billing_first_name = this.form.shipping_first_name;
				this.form.billing_last_name = this.form.shipping_last_name;
				this.form.billing_company = this.form.shipping_company;
				this.form.billing_street_address = this.form.shipping_street_address;
				this.form.billing_city = this.form.shipping_city;
				this.form.billing_postcode = this.form.shipping_postcode;
				// this.form.billing_country = this.form.shipping_country;
				this.form.state_id = this.form.shipping_state;
				this.form.billing_phone = this.form.shipping_phone;
			},
			PlaceOrder(data) {
				this.form.slot = data.slot;
				this.form.payment_method = data.payment_method;
				this.form.shipping_cost = this.GetDeliveryFee; // set delivery fee (shipping cost)
				if (this.isBillingIsSameAsShipping) {
					this.copyBillingAddressToShippingAddress();
				}
				const el = document.getElementsByClassName("page-style-a")[0];
				this.$smoothScroll({
					scrollTo: el, // scrollTo is also allowed to be number
				});
				//finally placing order here.
				this.placeOrder(this.form);
			},
			getCurrentLocation() {
				let location = JSON.parse(localStorage.getItem("location"));
				if (location) {
					(this.LatLng.lat = location.lat), (this.LatLng.lng = location.lng);
					this.getAddressFrom(this.LatLng.lat, this.LatLng.lng).then((res) => {
						this.formatted_address = res[0].formatted_address;
						//this.form.shipping_street_address = res[0].formatted_address;
					});
				}
			},
			handleCheckoutLocationModal() {},
			getAddressFrom(lat, lng) {
				return new Promise(async (resolve, reject) => {
					try {
						const res = await axios.get(
							"https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
								lat +
								"," +
								lng +
								"&key=AIzaSyA9Az_2wI5BBoLGDkkC8xXxO3b0pVtsGuU"
						);
						return resolve(res.data.results);
					} catch (error) {
						return reject(error);
					}
				});
			},
			validate: function (evt) {
				var key = evt.keyCode || evt.which;
				key = String.fromCharCode(key);
				var regex = /[0-9]|\./;
				if (!regex.test(key)) {
					evt.returnValue = false;
					if (evt.preventDefault) evt.preventDefault();
				}
			},
			scroll() {
				const el = document.getElementsByClassName("page-checkout")[0];
				if (el) {
					this.$smoothScroll({
						scrollTo: el, // scrollTo is also allowed to be number
					});
				}
			},
			async fetchStates() {
				try {
					const token = localStorage.getItem("token");
					let {data} = await axios.post(
						process.env.VUE_APP_API_URL + "/api/frontend/get-states",
						null,
						{
							headers: {
								Authorization: `Bearer ${token}`,
							},
						}
					);
					this.states = data.payload;
				} catch (error) {
					console.log(error);
				}
			},
		},
		mounted() {
			this.form.shipping_first_name = this.user.name.split(" ")[0];
			this.form.shipping_last_name = this.user.name.split(" ")[1]
				? this.user.name.split(" ")[1]
				: "";
			// setting default user details
			if (this.user.userdetails) {
				this.form.shipping_phone = this.user.userdetails.phone_no;
				this.form.shipping_street_address = this.user.userdetails.address;
			}
			this.BillingIsSameAsShipping(this.isBillingIsSameAsShipping);
			this.getCurrentLocation();
			this.scroll();
			this.fetchStates();
		},
	};
</script>

<style></style>
